import PropTypes from 'prop-types';
import adsBannerOrientationData from '../data/adsBannerOrientationData';
var policyListItem = PropTypes.shape({
  policyTitle: PropTypes.string.isRequired,
  policy: PropTypes.arrayOf(PropTypes.shape({
    policyItemBody: PropTypes.string.isRequired,
    policyItemTitle: PropTypes.string.isRequired
  }).isRequired).isRequired
}).isRequired;
var policyList = PropTypes.arrayOf(policyListItem);
var styleOptions = PropTypes.arrayOf(PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.string
}));
var adsItem = PropTypes.shape({
  title: PropTypes.string,
  collectionTitle: PropTypes.string,
  shortDescription: PropTypes.string,
  image: PropTypes.string,
  discount: PropTypes.number,
  url: PropTypes.string
});
var adsItems = PropTypes.arrayOf(adsItem);
var adsBannerOrientationOptions = PropTypes.oneOf(adsBannerOrientationData);
export default {
  policyList: policyList,
  policyListItem: policyListItem,
  styleOptions: styleOptions,
  adsItem: adsItem,
  adsItems: adsItems,
  adsBannerOrientationOptions: adsBannerOrientationOptions
};